import { DateBox } from "devextreme-react";
import { useState, useRef, useEffect } from "react";
import InformationErrorModal from "../../../../Components/Components/Modals/InformationErrorModal";
import { OfferCurrentView } from "../../../../Data/PageModeEnums.ts";
import { useOffers } from "../../../../Providers/OffersProvider.jsx";
import axios from "axios";
import { useParams } from "../../../../Providers/ParamsProvider.jsx";

const OffersFilter = ({ offersFilter, setOffersFilter, currentView }) => {
    const dateFromRef = useRef(null)
    const dateToRef = useRef(null)
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('')
    const [sellers, setSellers] = useState([])
    const [investments, setInvestments] = useState([])
    const { handleGetOfferFiltersData } = useOffers()
    const { isMobile } = useParams()

    useEffect(() => {
        const source = axios.CancelToken.source()

        clearFilters()
        setSellersAndInvestments(source.token)

        return () => {
            source.cancel()
        }
    }, [currentView])

    const setSellersAndInvestments = async (cancelToken) => {
        const result = await handleGetOfferFiltersData(currentView, offersFilter, cancelToken)
        if (result) {
            setInvestments(result.offerObjects.map(item => item.name))
            setSellers(result.sellers)
        }
        else {
            setSellers([])
            setInvestments([])
        }
    }

    const DateToOnValueChanged = (e) => {
        if (e.value) {
            const selectedDate = e.value.toLocaleString('en-CA').substring(0, 10)
            // if (dateFrom.length === 0) {
            //     setDateTo(selectedDate)
            if (selectedDate < offersFilter.dateFrom) {
                setErrorMessage('Data DO nie może być wcześniejsza niż data OD!')
                setShowError(true)
                if (dateToRef.current) {
                    dateToRef.current.instance.reset()
                }
                changeFilterValue('dateTo', null)
            } else {
                changeFilterValue('dateTo', selectedDate)
            }
        }
    }

    const DateFromOnValueChanged = (e) => {
        if (e.value) {
            const selectedDate = e.value.toLocaleString('en-CA').substring(0, 10);

            // if (dateTo.length === 0) {
            //     setDateFrom(selectedDate)
            if (selectedDate > offersFilter.dateTo) {
                setErrorMessage('Data OD nie może być poźniejsza niż data DO!')
                setShowError(true)
                if (dateFromRef.current) {
                    dateFromRef.current.instance.reset()
                }
                changeFilterValue('dateFrom', null)
            } else {
                changeFilterValue('dateFrom', selectedDate)
            }
        }
    }

    const clearFilters = () => {
        setOffersFilter(prev => ({
            ...prev,
            siteId: '',
            dateFrom: null,
            dateTo: null,
            invest: '',
            orderBy: 1,
        }))
        if (dateFromRef.current) {
            dateFromRef.current.instance.reset()
        }
        if (dateToRef.current) {
            dateToRef.current.instance.reset()
        }
    }

    const changeFilterValue = (props, value) => {
        setOffersFilter(prev => ({
            ...prev,
            [props]: value
        }))
    }

    return (<>
        <InformationErrorModal show={showError} setShow={setShowError} title={'Błędna data'} message={errorMessage} isError={false} />
        {isMobile ?
            <div className="row">
                <div className='col-6 date-filter'>
                    <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Od</label>
                    <DateBox acceptCustomValue={false} adaptivityEnabled={true} onValueChanged={DateFromOnValueChanged} ref={dateFromRef} />
                </div>
                <div className="col-6 date-filter">
                    <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Do</label>
                    <DateBox acceptCustomValue={false} adaptivityEnabled={true} onValueChanged={DateToOnValueChanged} ref={dateToRef} />
                </div>
                <div className="filters col-12 d-grid">
                    <div>
                        <label style={{ fontSize: '14px' }} htmlFor="investment">Inwestycja</label>
                        <select
                            style={{ fontSize: '14px' }}
                            id="investment"
                            value={offersFilter.invest}
                            onChange={(e) => changeFilterValue('invest', e.target.value)}
                        >
                            <option value="">Wszystkie inwestycje</option>
                            {investments.map((investment, index) => (
                                <option key={index} value={investment}>{investment}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label style={{ fontSize: '14px' }} htmlFor="seller">Sprzedający</label>
                        <select
                            style={{ fontSize: '14px', backgroundColor: currentView === OfferCurrentView.OfferRetailer ? '#f0f0f0' : 'white' }}
                            id="seller"
                            value={offersFilter.siteId}
                            onChange={(e) => changeFilterValue('siteId', e.target.value)}
                            disabled={(currentView === OfferCurrentView.OfferRetailer) ? true : false}
                        >
                            <option value="">Wszyscy sprzedający</option>
                            {sellers.map((seller, index) => (
                                <option key={index} value={seller.id}>{seller.name}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label style={{ fontSize: '14px' }} htmlFor="seller">Sortuj według</label>
                        <select
                            style={{ fontSize: '14px' }}
                            value={offersFilter.orderBy}
                            onChange={(e) => changeFilterValue('orderBy', e.target.value)}
                        >
                            <option value={1}>Najnowsze</option>
                            <option value={2}>Najstarsze</option>
                            <option value={3}>Nr oferty malejąco</option>
                            <option value={4}>Nr oferty rosnąco</option>
                            <option value={5}>Inwestycja malejąco</option>
                            <option value={6}>Inwestucja rosnąco</option>
                        </select>
                    </div>
                    <button
                        style={{ fontSize: '15px', height: '40px' }}
                        onClick={() => {
                            clearFilters()
                        }}
                        className='btn-app-primary'>
                        X
                    </button>
                </div>
            </div> :
            <div className="row">
                <div className='col-2 date-filter'>
                    <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Od</label>
                    <DateBox acceptCustomValue={false} adaptivityEnabled={true} onValueChanged={DateFromOnValueChanged} ref={dateFromRef} />
                </div>
                <div className="col-2 date-filter">
                    <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Do</label>
                    <DateBox acceptCustomValue={false} adaptivityEnabled={true} onValueChanged={DateToOnValueChanged} ref={dateToRef} />
                </div>
                <div className="filters col-7">
                    <div>
                        <label style={{ fontSize: '14px' }} htmlFor="investment">Inwestycja</label>
                        <select
                            style={{ fontSize: '14px' }}
                            id="investment"
                            value={offersFilter.invest}
                            onChange={(e) => changeFilterValue('invest', e.target.value)}
                        >
                            <option value="">Wszystkie inwestycje</option>
                            {investments.map((investment, index) => (
                                <option key={index} value={investment}>{investment}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label style={{ fontSize: '14px' }} htmlFor="seller">Sprzedający</label>
                        <select
                            style={{ fontSize: '14px', backgroundColor: currentView === OfferCurrentView.OfferRetailer ? '#f0f0f0' : 'white' }}
                            id="seller"
                            value={offersFilter.siteId}
                            onChange={(e) => changeFilterValue('siteId', e.target.value)}
                            disabled={(currentView === OfferCurrentView.OfferRetailer) ? true : false}
                        >
                            <option value="">Wszyscy sprzedający</option>
                            {sellers.map((seller, index) => (
                                <option key={index} value={seller.id}>{seller.name}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label style={{ fontSize: '14px' }} htmlFor="seller">Sortuj według</label>
                        <select
                            style={{ fontSize: '14px' }}
                            value={offersFilter.orderBy}
                            onChange={(e) => changeFilterValue('orderBy', e.target.value)}
                        >
                            <option value={1}>Najnowsze</option>
                            <option value={2}>Najstarsze</option>
                            <option value={3}>Nr oferty malejąco</option>
                            <option value={4}>Nr oferty rosnąco</option>
                            <option value={5}>Inwestycja malejąco</option>
                            <option value={6}>Inwestucja rosnąco</option>
                        </select>
                    </div>
                    <button
                        style={{ fontSize: '15px', width: '40px', height: '40px' }}
                        onClick={() => {
                            clearFilters()
                        }}
                        className='btn-app-primary mt-4'>
                        X
                    </button>
                </div>
            </div>}
    </>)
}

export default OffersFilter